import { Action } from 'redux';

import { SetVizPathActionType } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SetVizPathAction extends Action {
  vizPath: string;
}

export function setVizPath(vizPath: string): SetVizPathAction {
  return {
    type: SetVizPathActionType,
    vizPath
  };
}

export const isSetVizPathAction = isActionFactory<SetVizPathAction>(SetVizPathActionType);
